import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { useLanguage } from '../../contexts/LanguageContext';
import { LOGO_URL } from '../../data/links';
import { EASE_OUT } from '../../utils/motion';
import { AppWindow } from '../mockups/AppWindow';
import { ProductVideo } from '../mockups/ProductVideo';
import { SystemMock } from '../mockups/SystemMock';
import { PrimaryLink } from '../ui/PrimaryLink';
const enter = (delay: number) => ({
  initial: {
    opacity: 0,
    y: 16
  },
  animate: {
    opacity: 1,
    y: 0
  },
  transition: {
    duration: 0.3,
    delay,
    ease: EASE_OUT
  }
});
export function Hero() {
  const {
    t
  } = useLanguage();
  const ref = useRef<HTMLElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start start', 'end start']
  });
  const scale = useTransform(scrollYProgress, [0, 0.35], [0.94, 1]);
  const y = useTransform(scrollYProgress, [0, 1], [0, -60]);
  return <section ref={ref} id="top" className="relative overflow-hidden bg-ink pb-20 pt-28 md:pb-32 md:pt-36" data-id="element-160" data-mp="1ak4ockj6f3fa">
      <div className="mx-auto max-w-5xl px-5 text-center" data-id="element-161" data-mp="9lgaz0vlv8ut">
        <motion.img {...enter(0)} src={LOGO_URL} alt="Profumind" className="mx-auto mb-8 h-14 w-14 rounded-full md:h-16 md:w-16" data-id="element-162" data-mp="4ny5xlkplds3" />
        <motion.h1 {...enter(0.06)} className="text-[44px] font-semibold leading-[1.04] tracking-[-0.035em] text-white sm:text-6xl md:text-7xl lg:text-[88px]" data-id="element-163" data-mp="3ru797jn3u59f">
          {t.hero.title}
        </motion.h1>
        <motion.p {...enter(0.12)} className="mx-auto mt-5 max-w-2xl text-lg leading-snug text-muted md:mt-6 md:text-2xl" data-id="element-164" data-mp="nfzexgr76kf8">
          {t.hero.subtitle}
        </motion.p>
        <motion.div {...enter(0.18)} className="mt-9" data-id="element-165" data-mp="emngsue6txyu">
          <PrimaryLink href="#claridad" data-id="element-166" data-mp="1b51v0k66o57m">{t.hero.cta}</PrimaryLink>
        </motion.div>
      </div>

      <motion.div style={{
      scale,
      y
    }} className="mx-auto mt-14 max-w-6xl origin-top px-4 md:mt-20 md:px-6" data-id="element-167" data-mp="16djx64zgikqv">
        <motion.div {...enter(0.24)} data-id="element-168" data-mp="30mfl62r7ybjx">
          <AppWindow data-id="element-169" data-mp="35l0k7yuqip6s">
            <ProductVideo label={t.hero.videoLabel} fallback={<SystemMock data-id="element-171" data-mp="35k8moihkuhdv" />} data-id="element-170" data-mp="35ljqujexpr5i" />
          </AppWindow>
        </motion.div>
      </motion.div>
    </section>;
}